module.exports = __webpack_public_path__ + "static/comic-blue-background-small-68dfa9fc10ae1e7cd314afd517405210.svg";